interface MediaSliderCardBodyProps {
  imageUrl?: string;
  imageAlt?: string;
  title?: string | null;
  subtitle?: string | null;
}

/**
 * Inner content of a `MediaSlider` card: image (or grey fallback) + uppercase title + subtitle
 * line. The outer interactive wrapper (button vs link vs plain div) stays with the caller since
 * that differs by use case (programmatic navigation vs a real CMS link).
 */
export function MediaSliderCardBody({ imageUrl, imageAlt = '', title, subtitle }: MediaSliderCardBodyProps) {
  return (
    <>
      <div className="h-[320px] w-full overflow-hidden">
        {imageUrl ? (
          <img src={imageUrl} alt={imageAlt} className="size-full object-cover" />
        ) : (
          <div className="bg-jncquoi-neutral-100 size-full" />
        )}
      </div>
      <div className="flex flex-col gap-2">
        {title && (
          <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] font-semibold tracking-[0.5px]">
            {title}
          </p>
        )}
        {subtitle && (
          <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[16px] leading-normal tracking-[0.25px]">
            {subtitle}
          </p>
        )}
      </div>
    </>
  );
}
